module.exports = __webpack_public_path__ + "img/industry_solution1.b0de28f0.png";